import _ from "lodash";
import {addSingleDesignSync, searchDesignSyncsWithSearchCriteria} from "../services/design-sync-data-service";

export {
    getCurrentDesignSyncByType,
}

const getCurrentDesignSyncByType = async (type) => {
    let currentDesignSync;
    const searchCriteriaList = [];
    searchCriteriaList.push({
        field: 'status',
        condition: '==',
        value: 'NEW'
    });

    searchCriteriaList.push({
        field: 'type',
        condition: '==',
        value: type
    });

    let shopifyProductPriceSyncResultList = await searchDesignSyncsWithSearchCriteria(searchCriteriaList);

    if (_.isEmpty(shopifyProductPriceSyncResultList)) {
        const newDesignSync: any = {
            status: 'NEW',
            type: type
        }

        const newDesignSyncResult: any = await addSingleDesignSync(newDesignSync);
        newDesignSync.id = newDesignSyncResult.id;
        currentDesignSync = newDesignSync;
    } else {
        currentDesignSync = shopifyProductPriceSyncResultList[0];
    }

    return currentDesignSync;
}
